export default "/_next/static/images/3m-0f2e22996805859e0ad738cb676a71bf.svg";